<template>
  <div style="width:100%;float:left;">
    <CCard border-color="warning">
      <CCardHeader @click="show = !show">
        Timeline
        <div class="card-header-actions">
          <CLink class="card-header-action btn-minimize">
            <CIcon :name="`cil-chevron-${show ? 'bottom' : 'top'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="show" :duration="400">
        <CCardBody>
          <div style="width:100%;float:left;" v-if="!loading && data">
            <div class="item" v-for="val in data">
              <label class="itemText">{{val.text}}</label>
              <label class="itemDate">{{val.local_created_at}}</label>
              <spacer></spacer>
            </div>
          </div>
          <small-loader v-else></small-loader>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>
<script>
var methods = {}

methods.getTimeline = function () {
  this.loading = true
  const postData = {
    order_id: this.order_id,
    order_group_id: this.order_group_id
  }
    axios.post(this.$apiAdress + '/api/orders/getGroupTimeline?token=' + localStorage.getItem('api_token'), postData).then(res => {
      console.log(res)
        this.data = res.data
        this.loading = false
    }).catch(err => {
        console.log(err)
        this.loading = false
    })
}

export default {
    // ===Component name
    name: "GroupTimeline",
    // ===Props passed to component
    props: ['order_id', 'order_group_id'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
            data: null,
            loading: true,
            show: false
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
        this.getTimeline()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .item {
    width:100%;
    float:left;

    .itemText {
      width: 100%;
      float:left;
    }
    .itemDate {
      width:100%;
      float:left;
    }
  }
</style>
